common.View.create('crud::form.inputs.Switch', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initSwitch();
    },

    /**
     * Initializes the switch and prepares it for click events.
     */
    initSwitch()
    {
        // Define elements
        let button = this.element.find('button');
        let span = button.find('span');
        let input = button.find('input');

        // Define classes to switch
        const classes = {
            'button-on': 'bg-indigo-600',
            'button-off': 'bg-gray-200',
            'span-on': 'translate-x-5',
            'span-off': 'translate-x-0',
        }

        // If disabled add other classes
        if (input.attr('disabled')) {
            button.addClass('opacity-50 pointer-events-none');
        }

        // Listen for button click
        button.on('click', () =>
        {

            // Check if input isn't disabled
            if (input.attr('disabled')) return;

            // Invert current input value
            input.attr('checked', !input.attr('checked'))
                .val(input.attr('checked') ? '1' : '0');

            // Trigger change so you can listen on the event within other js files
            input.trigger('change');
            input.trigger('input');

            input.get(0).dispatchEvent(new Event('input'));

            // Check if input is checked
            if (input.attr('checked')) {
                // Switch classes for on state
                button.switchClass(classes["button-off"], classes["button-on"]);
                span.switchClass(classes["span-off"], classes["span-on"]);
            } else {
                // Switch classes for off state
                button.switchClass(classes["button-on"], classes["button-off"]);
                span.switchClass(classes["span-on"], classes["span-off"]);
            }
        });
    },
});
